<template>
  <header class="header">
    <div class="header-inner">
      <!-- ===== Logo ===== -->
      <router-link to="/" class="logo" title="">
        <img src="../../assets/logo.png" alt="" />
      </router-link>

      <!-- ===== 导航 ===== -->
      <nav class="nav">
        <router-link to="/hot" active-class="active">{{ $t('_h._zrm') }}</router-link>
        <router-link to="/latest" active-class="active">{{ $t('_h._zxd') }}</router-link>
        <router-link to="/ranking" active-class="active">{{ $t('_h._phb') }}</router-link>
        <router-link to="/wallpaper" active-class="active">{{ $t('_h._qz') }}</router-link>
      </nav>

      <!-- ===== 搜索 ===== -->
      <div class="search">
        <div class="search-box" :class="{ 'is-focus': searchFocus }">
          <i class="fas fa-search"></i>
          <input ref="searchInput" type="text" v-model="searchVal" :placeholder="$t('_h._ssww')" @focus="searchFocus = true" @blur="searchFocus = false" @input="onSearch" @keydown.enter="onSearchConfirm" />
          <i v-if="searchVal" class="fas fa-times-circle" @click="clearSearch"></i>
          <i v-if="searching" class="fas fa-spinner fa-spin"></i>
        </div>

        <!-- 搜索联想 -->
        <div v-if="searchList.length" class="search-dropdown">
          <div v-for="item in searchList" :key="item.code" class="search-item" @mousedown.prevent="goVideo(item.code)">
            <i class="fas fa-search"></i>
            <span>{{ item.title }}</span>
          </div>
        </div>
      </div>

      <!-- ===== 右侧 ===== -->
      <div class="actions">
        <Download />
        <Service v-if="isLogin" :chat_unread="userInfo.chat_unread" />
        <Language />

        <!-- 用户 -->
        <div @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
          <div class="user">
            <img :src="avatarUrl" class="avatar" />

            <!-- 下拉 -->
            <div class="dropdown" v-show="showDropdown">
              <div class="dropdown-box">
                <!-- 未登录 -->
                <template v-if="!isLogin">
                  <div class="drop-header">
                    <img :src="avatarUrl" class="drop-avatar" />
                    <div>
                      <div class="drop-name">Welcome</div>
                      <div class="drop-id">ID: ******</div>
                    </div>
                    <button class="btn-login" @click="onLoginShow">{{ $t('_h._dl') }}</button>
                    <button class="btn-register" @click="onRegisterShow">{{ $t('_h._zc') }}</button>
                  </div>
                  <hr />
                  <div class="drop-balance">
                    <span><b>0</b> {{ $t('_h._ye') }}</span>
                    <span><b>0</b> {{ $t('_h._dj') }}</span>
                  </div>
                </template>

                <!-- 已登录 -->
                <template v-else>
                  <div class="drop-header">
                    <img :src="avatarUrl" class="drop-avatar" />
                    <div>
                      <div class="drop-name">{{ userInfo.email }}</div>
                      <div class="drop-id">ID: {{ userInfo.uid }}</div>
                    </div>
                    <button class="btn-logout" @click="onSignOut">{{ $t('_h._tc') }}</button>
                  </div>
                  <hr />
                  <div class="drop-menu">
                    <router-link to="/dashboard"
                      ><span>{{ $t('_h._ybp') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link to="/wallet"
                      ><span>{{ $t('_h._wdqb') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link to="/record"
                      ><span>{{ $t('_h._scjl') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link to="/message"
                      ><span>{{ $t('_h._xxzx') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link to="/help"
                      ><span>{{ $t('_h._bzzx') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link to="/adv"
                      ><span>{{ $t('_h._ggtf') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link :to="userInfo.is_apply == 2 ? '/invest' : '/apply'">
                      <span>{{ $t('_h._bqtz') }}</span
                      ><i class="fas fa-chevron-right"></i>
                    </router-link>
                    <router-link to="/qualifications"
                      ><span>{{ $t('_cd._gszz') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                    <router-link to="/setting"
                      ><span>{{ $t('_h._sz') }}</span
                      ><i class="fas fa-chevron-right"></i
                    ></router-link>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <Login ref="loginBox" />
  </header>
</template>

<script>
import Language from './language.vue'
import Service from './service.vue'
import Download from './download.vue'
import Login from './Login.vue'

export default {
  name: 'HeadVue',
  components: { Language, Service, Download, Login },
  emits: ['search'],
  props: {
    // 是否启用搜索功能
    enableSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 用户
      isLogin: false,
      userInfo: {},
      // 搜索
      searchVal: '',
      searchList: [],
      searching: false,
      searchFocus: false,
      // 下拉
      showDropdown: false,
      // 防抖 timer
      searchTimer: null
    }
  },
  computed: {
    avatarUrl() {
      const defaultAvatar = require('../../static/img/icon_avatar.C-e_HuIE.png')
      if (!this.isLogin || !this.userInfo.avatar) return defaultAvatar
      return this.userInfo.avatar + '?t=' + Date.now()
    }
  },
  watch: {
    '$store.state.update.isUpdate'(val) {
      if (val) {
        this.refreshUser()
        this.$store.commit('update/setUpdate', false)
      }
    }
  },
  created() {
    this.init()
    if (this.$route.query?.t === 'login') {
      this.$nextTick(() => this.onLoginShow())
    }
  },
  methods: {
    // ===== 初始化 =====
    init() {
      this.isLogin = this.$common.isLogin()
      if (this.isLogin) this.refreshUser()
    },

    refreshUser() {
      this.$api.user.getUserInfo().then((res) => {
        this.userInfo = res.data
        localStorage.setItem(this.$Const.KEY_INFO, JSON.stringify(res.data))
      })
    },

    // ===== 登录 / 登出 =====
    onLoginShow() {
      // this.$refs.loginBox?.show()
      this.$router.push('/login')
    },
    onRegisterShow() {
      this.$router.push('/login?t=register')
    },
    onSignOut() {
      localStorage.removeItem(this.$Const.KEY_TOKEN)
      localStorage.removeItem(this.$Const.KEY_INFO)
      this.isLogin = false
      this.userInfo = {}
      this.$router.push('/')
    },

    // ===== 搜索 =====
    onSearch() {
      const val = this.searchVal.trim()

      if (this.enableSearch) {
        this.$emit('search', val)
        return
      }

      if (val.length < 2) {
        this.searchList = []
        return
      }

      clearTimeout(this.searchTimer)
      this.searching = true
      this.searchTimer = setTimeout(() => {
        this.$api.video
          .searchVideoList({ keyword: val })
          .then((res) => {
            this.searchList = res.data || []
          })
          .finally(() => {
            this.searching = false
          })
      }, 300)
    },

    onSearchConfirm() {
      if (this.searchList.length) {
        this.goVideo(this.searchList[0].code)
      }
    },

    goVideo(code) {
      this.$router.push({ name: 'video', query: { code } })
      this.searchList = []
      this.searchVal = ''
      this.$refs.searchInput?.blur()
    },

    clearSearch() {
      this.searchVal = ''
      this.searchList = []
      this.$refs.searchInput?.focus()
    }
  }
}
</script>

<style scoped>
/* ============================================================
   1. 基础
   ============================================================ */
.header {
  position: sticky;
  top: 0;
  z-index: 999;
  background: rgba(11, 13, 15, 0.92);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid #1a1f26;
}

.header-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 0 24px;
  height: 70px;
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
}

/* ============================================================
   2. Logo
   ============================================================ */
.logo {
  flex-shrink: 0;
}
.logo img {
  height: 34px;
  display: block;
}

/* ============================================================
   3. 导航
   ============================================================ */
.nav {
  display: flex;
  gap: 4px;
}
.nav a {
  padding: 6px 16px;
  border-radius: 8px;
  color: #fff;
  font-size: 17px;
  font-weight: 500;
  text-decoration: none;
  transition: 0.2s;
}
.nav a:hover {
  color: #e8edf2;
  background: rgba(255, 255, 255, 0.06);
}
.nav a.active {
  color: #fff;
  background: rgba(229, 9, 20, 0.18);
}

/* ============================================================
   4. 搜索
   ============================================================ */
.search {
  flex: 1;
  max-width: 440px;
  position: relative;
}

.search-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #141a20;
  border-radius: 24px;
  padding: 0 14px;
  border: 1px solid #1e262e;
  transition: 0.25s;
}
.search-box.is-focus {
  border-color: #e50914;
  box-shadow: 0 0 0 3px rgba(229, 9, 20, 0.12);
}

.search-box i {
  color: #5a6672;
  font-size: 14px;
  flex-shrink: 0;
}
.search-box .fa-times-circle {
  cursor: pointer;
}
.search-box .fa-times-circle:hover {
  color: #e8edf2;
}
.search-box .fa-spinner {
  animation: spin 0.8s linear infinite;
}

.search-box input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: #e8edf2;
  font-size: 14px;
  padding: 9px 0;
  min-width: 60px;
}
.search-box input::placeholder {
  color: #4a5662;
}

/* 搜索下拉 */
.search-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: #141a20;
  border-radius: 12px;
  border: 1px solid #1e262e;
  box-shadow: 0 12px 48px rgba(0, 0, 0, 0.6);
  overflow: hidden;
  padding: 6px 0;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  color: #b0bcc8;
  font-size: 14px;
  cursor: pointer;
  transition: 0.15s;
}
.search-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #e8edf2;
}
.search-item i {
  color: #5a6672;
  font-size: 12px;
}
.search-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ============================================================
   5. 右侧操作区
   ============================================================ */
.actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
}

/* ============================================================
   6. 用户
   ============================================================ */
.user {
  position: relative;
  padding: 4px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-box {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user:hover {
  background: rgba(255, 255, 255, 0.04);
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  border: 2px solid transparent;
  transition: 0.25s;
}
.user:hover .avatar {
  border-color: #e50914;
}

/* ===== 下拉菜单 ===== */
.dropdown {
  position: absolute;
  top: calc(100% + 0px);
  right: 0;
  transition: 0.2s;
  padding-top: 18px;
}

.dropdown-box {
  width: 220px;
  background: #141a20;
  border-radius: 14px;
  border: 1px solid #1e262e;
  box-shadow: 0 16px 64px rgba(0, 0, 0, 0.7);
  padding: 16px;
}

.dropdown hr {
  border: none;
  border-top: 1px solid #1e262e;
  margin: 12px 0;
}

/* 头部 */
.drop-header {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-direction: row;
  flex-wrap: wrap;
}
.drop-avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.drop-name {
  color: #e8edf2;
  font-size: 15px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 120px;
}
.drop-id {
  color: #5a6672;
  font-size: 15px;
}

.btn-login,
.btn-logout {
  padding: 4px 16px;
  border-radius: 16px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: 0.2s;
}
.btn-login {
  background: #e50914;
  color: #fff;
}
.btn-login:hover {
  background: #b20710;
}
.btn-logout {
  background: rgba(255, 255, 255, 0.07);
  color: #8a949f;
}
.btn-logout:hover {
  background: rgba(229, 9, 20, 0.15);
  color: #e50914;
}

.btn-register {
  background: #f3ad09;
  color: #fff;
  padding: 4px 16px;
  border-radius: 16px;
  border: none;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: 0.2s;
}
.btn-register:hover {
  background: #cf9902;
}

/* 余额 */
.drop-balance {
  display: flex;
  gap: 20px;
}
.drop-balance span {
  color: #5a6672;
  font-size: 13px;
}
.drop-balance b {
  color: #e8edf2;
  font-size: 16px;
  margin-right: 4px;
}

/* 菜单列表 */
.drop-menu {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.drop-menu a {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 10px;
  border-radius: 8px;
  color: #b0bcc8;
  font-size: 15px;
  text-decoration: none;
  transition: 0.15s;
}
.drop-menu a:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #e8edf2;
}
.drop-menu a i {
  color: #3a4652;
  font-size: 11px;
}

/* ============================================================
   7. 工具
   ============================================================ */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ============================================================
   8. 响应式
   ============================================================ */
@media (max-width: 1024px) {
  .header-inner {
    padding: 0 16px;
    gap: 16px;
  }
  .search {
    max-width: 300px;
  }
}

@media (max-width: 768px) {
  .header-inner {
    height: 54px;
    padding: 0 12px;
    gap: 10px;
  }
  .nav a {
    padding: 4px 10px;
    font-size: 17px;
  }
  .search {
    max-width: 160px;
  }
  .search-box input {
    font-size: 13px;
    padding: 7px 0;
  }
  .logo img {
    height: 28px;
  }
  .avatar {
    width: 28px;
    height: 28px;
  }
  .dropdown {
    width: 250px;
    right: -8px;
    padding: 14px;
  }
}

@media (max-width: 480px) {
  .nav {
    display: none;
  }
  .search {
    max-width: 120px;
    min-width: 80px;
  }
  .search-box {
    padding: 0 10px;
  }
  .search-box input {
    font-size: 12px;
    min-width: 40px;
  }
  .search-box i {
    font-size: 12px;
  }
  .dropdown {
    width: 230px;
    right: -12px;
    padding: 12px;
  }
  .drop-name {
    max-width: 80px;
    font-size: 15px;
  }
  .drop-avatar {
    width: 36px;
    height: 36px;
  }
}
</style>
